import {Component} from "@angular/core";
import {HttpHeaders, HttpClient} from "@angular/common/http";
import {ICellRendererParams} from "@ag-grid-community/core";

@Component({
   selector: 'download-file-component',
   template: `
        <a (click)="downloadFile()" style="cursor:pointer">
          <img border="0" src="assets/download.png" width="20" height="20">
        </a>
   `
})
export class DownloadFileCellRenderer {
   private cellValue: string;

  constructor(private http: HttpClient) {}

   // gets called once before the renderer is used
   agInit(params: ICellRendererParams): void {
       this.cellValue = this.getValueToDisplay(params);
   }

   // gets called whenever the cell refreshes
   refresh(params: ICellRendererParams) {
       // set value into cell again
       this.cellValue = this.getValueToDisplay(params);
   }
   downloadFile() {
    try {
      const url = window.location.origin + '/api/plsnapshot/get-report?path=' + this.cellValue;
      const filename = url.substring(url.lastIndexOf('/')+1)
      let headers = new HttpHeaders()
        .set('Accept', 'application/pdf');
      this.http
        .get(`${url}`, {
          headers: headers,
          responseType: 'blob'
        })
        .subscribe(
        data => {
            // With FileName
            const blob: Blob = new Blob([data], { type: 'application/pdf' });
            const objectUrl: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

            a.href = objectUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
          },
          error => console.log('oops', error)
        );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

   getValueToDisplay(params: ICellRendererParams) {
       return params.valueFormatted ? params.valueFormatted : params.value;
   }
}
